import { SvgIcon, type SvgIconProps } from "@mui/material";

import crowdCoursingLogoUrl from "./CrowdCoursing-Logo--updated.png";

/** PNG canvas is 2172×724; crop to visible logo bounds (excludes transparent padding). */
const LOGO_VIEWBOX = "111 208 1926 308";
const IMAGE_WIDTH = 2172;
const IMAGE_HEIGHT = 724;

export function CrowdCoursingLogo({ ...props }: SvgIconProps) {
  return (
    <SvgIcon viewBox={LOGO_VIEWBOX} {...props} sx={{ height: "unset", width: "unset", ...props.sx }}>
      <image
        height={IMAGE_HEIGHT}
        href={crowdCoursingLogoUrl}
        preserveAspectRatio="xMidYMid meet"
        width={IMAGE_WIDTH}
      />
    </SvgIcon>
  );
}
